import * as React from "react";
import {observer} from "mobx-react";
import {Label, Icon, IconButton} from "@vidazoo/ui-kit";
import theme from "./theme.module.scss";
import useRouterService from '../../router/hooks/useRouterService';
import UrlsService from '../../router/services/urlsService.mdl';
import {ChartType} from '../../enums/ChartType';
import {ChartEditModel} from '../../../modules/charts/item/edit/model/ChartEditModel.mdl';
import {ChartCreateModel} from '../../../modules/charts/item/create/model/ChartCreateModel.mdl';

export interface IChartHeaderProps {
    chartModel: ChartEditModel | ChartCreateModel;
    isEditMode: boolean;
    appearance?: 'default' | 'classic';
    onDeleteClick?: (chartId: string) => void;
}

export default observer(function ChartHeader(props: IChartHeaderProps) {
    const {chartModel, isEditMode, onDeleteClick, appearance} = props;
    const routerService = useRouterService();
    const chart = chartModel.item.data;

    const onDelete = () => {
        onDeleteClick && onDeleteClick(chart._id);
    };

    const onEditClick = () => {
        routerService.push(UrlsService.editChart(chart._id));
    };

    const renderDownloadCsvButton = () => {
        const report = chartModel.data;
        if (!report) {
            return null;
        }
        return (chart.type === ChartType.DATA_TABLE && !isEditMode) ? (
            <IconButton style={appearance === 'classic' ? {width: '4rem', height: '4rem'} : undefined} aria-label={`Download CSV for ${chart.name}`} iconName="icon-download" iconColor={appearance === 'classic' ? 'white' : undefined} blue onClick={chartModel.downloadCSV}/>) : null;
    };

    if (!chart) {
        return null;
    }

    return (
        <div className={theme.container}>
            <Label size={appearance === 'classic' ? 13 : 18} monserrat={appearance === 'classic'} spacing={1.25}>{chart.name}</Label>
            <div className={theme.actions}>
                {isEditMode ? (
                    <>
                        {onDeleteClick ? (
                            <button type="button" aria-label={`Remove ${chart.name} from dashboard`} className={theme.action} onClick={onDelete}>
                                <Icon iconColor="currentColor" size={2}
                                      iconName="icon-delete"/>
                            </button>
                        ) : null}

                        <button type="button" aria-label={`Edit chart ${chart.name}`} className={theme.action} onClick={onEditClick}>
                            <Icon iconColor="currentColor" size={2} iconName="icon-edit"/>
                        </button>
                    </>
                ) : null}
            </div>
            {renderDownloadCsvButton()}
        </div>
    );
});
